<template>

	<modal :show.sync="showModal" >
		<delete-contact :contact.sync="contactToDelete"></delete-contact>
	</modal>
  <modal :show.sync="showModalContacts" >
    <delete-contacts :contacts="contactsToDelete"></delete-contacts>
  </modal>

  <div class="card card-content">
    <div class="card-header">
      <div class="header">
        <!-- <breadcrumb></breadcrumb> -->
        <div class="breadcrumb">
          <a class="breadcrumb-item" v-link="{ path: '/'}">Accueil</a>
          <a class="breadcrumb-item" v-link="{ path: '/contact/list'}">Gestion des participants</a>
        </div>
        <h1>Participants</h1>
      </div>
      <div class="actions">
        <a class="btn btn-link" v-link="{ path: '/contact/add'}" >Ajouter un nouveau participant</a>
        <a class="btn btn-link" v-link="{ name: 'addProjectWithContact', params: { contactId: contact.id } }">Ajouter un parcours</a>
        <a class="btn btn-link" v-link="{ name: 'addMeetingWithContact', params: { contactId: contact.id } }">Ajouter un rdv</a>
      </div>
    </div>
    <table class="table table-hover table-widget">
      <thead>
      <tr>
        <td colspan="2">
          <select v-model="rowPerPage" class="form-control">
            <option value="10">10 lignes</option>
            <option value="100">100 lignes</option>
            <option value="500">500 lignes</option>
          </select>
        </td>
        <td colspan="3" class="text-xs-right">{{ contacts.length }} participants enregistrés</td>
      </tr>
      <tr>
        <td colspan="4">
          <button class="btn btn-link btn-sm" v-on:click="selectAll">Selectionner tout</button>
          <button class="btn btn-link btn-sm" v-on:click="selectVisible">Selectionner visible</button>
          <button class="btn btn-link btn-sm" v-on:click="unselect" v-if="selected.length">Déselectionner</button>

          <span class="btn btn-sm">{{ selected.length }} sélectionnés</span>
        </td>
        <td>
          <div class="form-inline" style="text-align: right;display:none;">
            <select name="" id="actionsList" class="form-control form-control-sm" v-model="bulk_action">
              <option value="none">Action</option>
              <option value="delete">Supprimer</option>
            </select>
            <button class="btn btn-primary btn-sm" v-if="active_bulk_action" v-on:click="executeBulkAction">Executer</button>
          </div>
        </td>
      </tr>
      <tr>
        <th></th>
        <th @click="sort('gender')">Civilité&nbsp;<span :class="getClass('gender')"></span></th>
        <th @click="sort('leader_lastname')">Nom&nbsp;<span :class="getClass('leader_lastname')"></span></th>
        <th @click="sort('leader_firstname')">Prénom&nbsp;<span :class="getClass('leader_firstname')"></span></th>
        <th width="250px">&nbsp;</th>
      </tr>
      <tr>
        <td>&nbsp;</td>
        <td>
          <select class="form-control" v-model="filter_gender">
            <option value=""></option>
            <!--<option value="1">Melle</option>§-->
            <option value="2">Mme</option>
            <option value="3">M</option>
          </select>
        </td>
        <td><input type="text" class="form-control" v-model="filter_leader_lastname"></td>
        <td><input type="text" class="form-control" v-model="filter_leader_firstname"></td>
        <td>&nbsp;</td>
      </tr>
      </thead>
      <tbody>
      <tr v-for="(index, contact) of page" v-on:click="preview(contact)" v-bind:class="{active: isActive(contact)}">
        <td><input type="checkbox" value="{{ contact.id }}" v-model="selected"></td>
        <td>{{ genders[contact.gender -1] }}</td>
        <td>{{ contact.leader_lastname }}</td>
        <td>{{ contact.leader_firstname }}</td>
        <td class="text-xs-right">
            <button class="btn btn-primary" v-link="{ name: 'editContact', params: { contactId: contact.id }}">Editer</button>
            <button class="btn btn-warning" @click="modalDelete(contact)">Supprimer</button>
        </td>
      </tr>
      </tbody>
    </table>
    <div class="text-xs-center">
        <pagination :records="row" :row-per-page="rowPerPage"></pagination>
    </div>
  </div>
</template>

<script>
	// Components
    import Modal from '../modals/Modal.vue'
    import DeleteContact from '../modals/DeleteContact.vue'
    import DeleteContacts from '../modals/DeleteContacts.vue'
    import Pagination from '../grid/Pagination.vue'
    import Breadcrumb from '../nav/Breadcrumb.vue'

    import { contacts, contact } from '../../vuex/getters'
    import { getContacts, getContact } from '../../vuex/actions/contactActions'

    export default{
      vuex: {
        getters: { contacts, contact },
        actions: { getContacts, getContact }
      },
      data () {
        return {
          orderType: '',
          orderAsc: -1,
          showModal: false,
          contactToDelete: null,
          showModalContacts: false,
          contactsToDelete: null,
          genders: ['Melle', 'Mme', 'M'],
          rowPerPage: 10,
          page: [],
          filter_gender: '',
          filter_leader_lastname: '',
          filter_leader_firstname: '',
          row: [],
          selected: [],
          bulk_action: 'none',
          active_bulk_action: false,
          active: {}
        }
      },
      watch: {
        filter_gender: function () {
          this.filter()
        },
        filter_leader_lastname: function () {
          this.filter()
        },
        filter_leader_firstname: function () {
          this.filter()
        },
        row: function () {
          this.page = this.row.slice(0, this.rowPerPage)
        },
        rowPerPage: function () {
          this.page = this.row.slice(0, this.rowPerPage)
        },
        contacts: function () {
          this.row = Array.from(this.contacts)
          this.orderType = ''
          this.sort('leader_lastname')
        },
        bulk_action: function () {
          this.active_bulk_action = (this.bulk_action !== 'none' && this.selected.length > 0)
        },
        selected: function () {
          this.active_bulk_action = (this.bulk_action !== 'none' && this.selected.length > 0)
        }
      },
      methods: {
        getClass (property) {
          if (this.orderType === property) {
            if (this.orderAsc === -1) {
              return 'icon-sort-asc'
            }
            return 'icon-sort-desc'
          }
          return 'icon-unsorted'
        },
        sort (filter) {
          if (this.orderType === filter) {
            this.orderAsc = this.orderAsc * -1
            this.row.reverse()
          } else {
            this.orderType = filter
            this.row.sort(function (a, b) {
              if (a[filter] < b[filter]) return -1
              if (a[filter] > b[filter]) return 1
              return 0
            })
          }
        },
        filter () {
          let row = Array.from(this.contacts)

          row = this.filterElement('gender', this.filter_gender, row)
          row = this.filterElement('leader_lastname', this.filter_leader_lastname, row)
          row = this.filterElement('leader_firstname', this.filter_leader_firstname, row)

          this.row = row
        },
        filterElement (filter, text, row) {
          // console.log(text)
          let search = new RegExp('^' + text, 'i')
          let search2 = new RegExp('^ ' + text, 'i')
          row = row.filter(function (contact) {
            // console.log('contact ' + filter + ' : ' + contact[filter] + ' for ' + search)
            if (text === '') return true
            else {
              // console.log('|' + contact[filter] + '| : ' + filter + ' for ' + search + ' ' + contact[filter].search(search))
              if (contact[filter].search(search) !== -1) {
                return true
              } else if (contact[filter].search(search2) !== -1) {
                return true
              } else {
                return false
              }
              // return (contact[filter].search(search) !== -1)
            }
          })

          return row
        },
        add () {
          this.addContact()
        },
        modalDelete (contact) {
          this.contactToDelete = contact
          this.showModal = true
        },
        preview (contact) {
          this.getContact(contact.id)
            .then(() => {
              contact = this.contact
              this.active = contact
              let data = [
                { label: 'Nom', value: contact.leader_firstname },
                { label: 'Prenom', value: contact.leader_lastname },
                { label: 'Adresse', value: contact.address },
                { label: 'Code postal', value: contact.zip },
                { label: 'Ville', value: contact.city },
                { label: 'Téléphone', value: contact.phone },
                { label: 'Mobile', value: contact.mobile },
                { label: 'Email', value: contact.email }
              ]
              this.$dispatch('preview-data', data)
            })
        },
        isActive: function (contact) {
          return this.active === contact
        },
        selectAll () {
          let selected = []
          this.row.forEach(function (contact) {
            selected.push(contact.id.toString())
          })

          this.selected = selected
        },
        selectVisible () {
          let selected = []
          this.page.forEach(function (contact) {
            selected.push(contact.id.toString())
          })

          this.selected = selected
        },
        unselect () {
          this.selected = []
        },
        executeBulkAction () {
          let that = this
          let contactToDelete = this.contacts.filter(function (contact) {
            return that.selected.indexOf(contact.id.toString()) !== -1
          })

          switch (this.bulk_action) {
            case 'delete':
              this.contactsToDelete = contactToDelete
              this.showModalContacts = true
              break
          }
        }
      },
      components: {
        Modal,
        DeleteContact,
        DeleteContacts,
        Pagination,
        Breadcrumb
      },
      events: {
        'deleteContact': function () {
          if (this.contactToDelete) {
            this.deleteContact(this.contactToDelete)
            this.contactToDelete = null
          }
        },
        'after-delete-contacts': function () {
          this.contactsToDelete = null
          this.selected = []
        },
        'change-page': function (index) {
          let start = (index - 1) * this.rowPerPage
          this.page = this.row.slice(start, start + this.rowPerPage)
        }
      },
      ready () {
        this
          .getContacts()
      }
    }
</script>



// WEBPACK FOOTER //
// ContactsList.vue?7d663ab1